import { ShoppingListProductModel } from '../../../../types/ShoppingListProduct';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareDeleteShoppingListProduct = ({
    shoppingListProductElement,
}: {
    shoppingListProductElement: ShoppingListProductModel;
}) => shoppingListProductElement.prepareMarkAsDeleted();

export const logDeleteShoppingListProductAction = ({
    shoppingListProductElement,
    logDBAction,
    tableName,
}: {
    shoppingListProductElement: ShoppingListProductModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Delete shopping list product',
        modelName: tableName,
        payload: shoppingListProductElement,
    });
};
